import { Modal, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { URButton } from "../../../shared/widgets/button";
import { URCheckBox } from "../../../shared/widgets/checkbox";
import styles from "./scss/chattopics.module.scss";
import { chats, contacts, initialStateModel, LoginState } from "../../../models/model";
import { useSelector } from "react-redux";
import { ChatService } from "../../../base/chatService";
//import ChatLike from '../chatWidgets/chatLike';
import ChatUserInfo from "../chatWidgets/chatUserInfo";
import store from "../../../context/store/store";
import iconpdf from "../../../styles/images/grid_pdf.svg";
import iconppt from "../../../styles/images/grid_ppt.svg";
import iconword from "../../../styles/images/grid_word.svg";
import iconxls from "../../../styles/images/grid_xls.svg";
import iconzip from "../../../styles/images/grid_zip.svg";
import ChatRightInfo from "../chatWidgets/chatRightInfo";
import {
  excelFormats,
  getcontactDetail,
  getFileSize,
  imageFormat,
  mp3Formats,
  pdfFormats,
  pptFormats,
  SearchFilter,
  urlify,
  videoFormat,
  zipFormats
} from "../../../base/utils";
import ChatAudioInner from "../chatWidgets/chatAudioInner";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../../base/callService/common";
import _ from "lodash";
import { Types } from "../../../context/action/action";
import teamIcn from "../../../styles/images/teamimg.svg";

export default function Deleteconfirmsec() {
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let { allContacs }: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let ffRes: boolean = chatReducer?.forwardType === 'single' ? true : false;
  let delRes: boolean = chatReducer?.deleteType === 'single' ? true : false;
  const [isModalVisible, setIsModalVisible] = useState(delRes);
  const [isForwardModalVisible, setForwardModalVisible] = useState(ffRes);
  const [visible, setvisible] = useState(false);
  let allcontactfilter = allContacs.filter((data: any) => {
    if (data?.team_id && data?.team_members && data?.team_members?.includes(userdetails?.sip_login_id)) {
      return data;
    } else if (data?.sip_login_id) return data;
  });

  const [shareContact, setshareContact] = useState({
    contactList: allcontactfilter,
    searchContactList: allcontactfilter,
    contactDetail: [],
    selectedmember: []
  });
  useEffect(() => {
    if (chatReducer?.forwardType === 'multi') {
      setForwardModalVisible(true);
    }
    if (chatReducer?.deleteType === 'multi') {
      setIsModalVisible(true);
    }


  }, [chatReducer?.forwardType, chatReducer?.deleteType]);
  const showModal = () => {
    if (chatReducer?.selectMessageData?.length > 0) {
      if (chatReducer.isDelete) {
        setIsModalVisible(true);
      }
      if (chatReducer.isForward) {
        setForwardModalVisible(true);
      }
    }
  };

  const handleOk = () => {
    if (chatReducer.isDelete) {
      ChatService.onDeleteMesage(chatReducer?.selectMessageData);
      setIsModalVisible(false);
      setshareContact({ ...shareContact, contactDetail: [], selectedmember: [] });
      ChatService.onChangeDeleteWindow(false, '');
    }
    if (chatReducer.isForward) {
      setForwardModalVisible(false);
      ChatService.forwardMessage(chatReducer?.selectMessageData, shareContact.contactDetail);
      setshareContact({ ...shareContact, contactDetail: [], selectedmember: [] });
      ChatService.onChangeForwardWindow(false, '');
      toastInformation("Message Shared");
    }
    hideCancel();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setForwardModalVisible(false);
    setshareContact({ ...shareContact, selectedmember: [] });
    hideCancel();
    ChatService.onMultiOptionWindow(false);
  };

  const hideCancel = () => {
    if (chatReducer.multiOption || chatReducer.isDelete) {
      ChatService.onChangeDeleteWindow(false, '');
      setIsModalVisible(false);
    }
    if (chatReducer.multiOption || chatReducer.isForward) {
      ChatService.onChangeForwardWindow(false, '');
      setForwardModalVisible(false);
    }
    ChatService.onMultiOptionWindow(false);
  };

  const onChangeSelectMembers = (e: any) => {
    let { userdetails }: LoginState = store.getState().loginReducer;
    let contact: any = e.map((item: string) => {
      return getcontactDetail(item.toString(), shareContact.contactList, userdetails);
    });
    setshareContact({
      ...shareContact,
      selectedmember: e,
      searchContactList: shareContact.contactList,
      contactDetail: contact
    });
  };

  const onSearchMembers = (value: any) => {
    let response = SearchFilter(shareContact.contactList, value.toLowerCase());
    setshareContact({ ...shareContact, searchContactList: response });
  };
  const handleCheckBoxClick = (e: any) => {
    let deletedArray: any = _.filter(chatSocketMessage?.messageList, function (o) {
      return (
        o.direction === "OUT" &&
        o.message?.isDelete?.all !== 1 &&
        !o.message?.isDeleted &&
        (o.message?.messageType === "TEXT" || o.message?.messageType === "FILE" || o.message?.messageType === "IMAGE")
      );
    });

    if (e.target.checked) {
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: deletedArray
        }
      });
      setvisible(true);
    } else {
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: []
        }
      });
      setvisible(false);
    }
  };

  let len = Math.ceil(shareContact?.searchContactList?.length / 8);
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  return (
    <>
      {chatReducer?.multiOption && <div className={styles.DeleteBtnsec}>
        {chatReducer?.selectMessageData?.length > 0 && (
          <span className={styles.selectVal}>{`${chatReducer?.selectMessageData?.length} Selected`} </span>
        )}
        <URButton onClick={hideCancel} className={styles.cancelbtn} name="Cancel" />
        {/* {chatReducer.isDelete && (
          <URButton
            onClick={showModal}
            className={`${styles.deletebtn} ${chatReducer?.selectMessageData?.length > 0 ? "" : styles.disabled}`}
            name="Delete"
          />
        )} */}
        {/* {chatReducer.isForward && (
          <URButton
            onClick={showModal}
            className={`${styles.savebtn} ${chatReducer?.selectMessageData?.length > 0 ? "" : styles.disabled}`}
            name="Select Contact"
          />
        )} */}
        {!chatReducer.isDelete && (
          <Tooltip title="Select all" className="cusTooltip" overlayClassName="customTooltip">
            {" "}
            <URCheckBox className="chatTopicCheckbox" onChange={handleCheckBoxClick} checked={visible} />
          </Tooltip>
        )}
      </div>}

      <Modal
        title="Delete Message"
        centered
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText="Cancel"
        okText="Delete Chat"
        cancelButtonProps={{ className: "urButton buttonWhite" }}
        okButtonProps={{ className: "urButton buttonRed" }}
        className={`customPopup shareModel ${styles.newdeletechat}`}
      >
        <div className="deletetextmsg">
          Are you sure you want to permanently delete {chatReducer?.selectMessageData?.length > 1 ? "these" : "this"}{" "}
          messages?
        </div>
        {/* <div className=" scroller deleteScroll">
          {Array.isArray(chatReducer?.selectMessageData) &&
            chatReducer?.selectMessageData.map((data: any) => {
              let messageBody =
                data.message?.messageType === "IMAGE" || data.message?.messageType === "FILE" ? data.message.body : "";

              return (
                <>
                  <div className={styles.chatConSecBody}>
                    {(data.message?.messageType === "TEXT" || data.message?.messageType === "AT_MENTION") && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>
                          <ChatRightInfo
                            userDetails={data.fromcaller_details}
                            isPopup={true}
                            timeStamp={data.timestamp}
                            message={data}
                          ></ChatRightInfo>
                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                            <p dangerouslySetInnerHTML={{ __html: urlify(data.message.body)}}></p>
                          
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {data.message?.messageType === "IMAGE" && imageFormat.indexOf(messageBody.fileType) !== -1 && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>
                          <ChatRightInfo
                            userDetails={data.fromcaller_details}
                            isPopup={true}
                            timeStamp={data.timestamp}
                            message={data}
                          ></ChatRightInfo>
                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                              <div className={styles.imageChat}>
                                <div className={styles.imageSec}>
                                  <img src={messageBody.filePath} alt="" />
                                </div>
                              </div>
                       
                            </div>
                            <Tooltip title="Today at 12:13 PM" className="cusTooltip" overlayClassName="customTooltip">
                              <div className={styles.chatTime}>12:13</div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    )}
                    {data.message?.messageType === "FILE" && videoFormat.indexOf(messageBody.fileType) !== -1 && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>
                          <ChatRightInfo
                            userDetails={data.fromcaller_details}
                            isPopup={true}
                            timeStamp={data.timestamp}
                            message={data}
                          ></ChatRightInfo>
                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                              <div className={styles.imageChat}>
                                <div className={styles.imageSec}>
                                  <video controls>
                                    <source src={messageBody?.filePath} type="video/mp4" />
                                  </video>
                                </div>
                              </div>
                    
                            </div>
                            <Tooltip title="Today at 12:13 PM" className="cusTooltip" overlayClassName="customTooltip">
                              <div className={styles.chatTime}>12:13</div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    )}

                    {data.message?.messageType === "FILE" &&
                      imageFormat.indexOf(messageBody.fileType) === -1 &&
                      videoFormat.indexOf(messageBody.fileType) === -1 &&
                      mp3Formats.indexOf(messageBody.fileType) === -1 && (
                        <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                          <div className={`${styles.chatUserDetails}`}>
                            <ChatRightInfo
                              userDetails={data.fromcaller_details}
                              isPopup={true}
                              timeStamp={data.timestamp}
                              message={data}
                            ></ChatRightInfo>
                            <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide" />
                          </div>
                          <div className={styles.chatRightMessages}>
                            <div className={styles.chatRight}>
                              <div className={styles.chatContent}>
                                <div className={styles.chatAttachmentList}>
                                  <div className={styles.filesChat}>
                                    <div className={styles.filesImage}>
                                      {zipFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconzip} alt="filename" />
                                      ) : pdfFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconpdf} alt="filename" />
                                      ) : messageBody.fileType && pptFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconppt} alt="filename" />
                                      ) : excelFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconxls} alt="filename" />
                                      ) : (
                                        <img src={iconword} alt="filename" />
                                      )}
                                    </div>
                                    <div className={styles.filesDetails}>
                                      <Tooltip
                                        placement="top"
                                        title={messageBody.fileName}
                                        overlayClassName="tooltipCenter"
                                      >
                                        <span className={styles.fileName}>
                                          {messageBody.fileName && messageBody.fileName.length > 25
                                            ? messageBody.fileName.substring(0, 25) + "..."
                                            : messageBody.fileName}
                                        </span>
                                      </Tooltip>
                                      <span className={styles.fileDt}>
                                        File size:{getFileSize(messageBody?.filesize)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                        
                              </div>
                              <Tooltip
                                title="Today at 12:13 PM"
                                className="cusTooltip"
                                overlayClassName="customTooltip"
                              >
                                <div className={styles.chatTime}>12:13</div>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      )}
                    {data.message?.messageType === "FILE" && mp3Formats.indexOf(messageBody.fileType) !== -1 && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>
                          <ChatRightInfo
                            userDetails={data.fromcaller_details}
                            isPopup={true}
                            timeStamp={data.timestamp}
                            message={data}
                          ></ChatRightInfo>
                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                              <div className={styles.chatAudioList}>
                                <ChatAudioInner data={data} userDetails={data.fromcaller_details} />
                          
                              </div>
                            </div>
                            <Tooltip title="Today at 12:13 PM" className="cusTooltip" overlayClassName="customTooltip">
                              <div className={styles.chatTime}>12:13</div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              );
            })}
        </div> */}
      </Modal>
      <Modal
        title={
          shareContact.contactDetail.length > 0
            ? `Selected Contact (${shareContact.contactDetail.length})`
            : "Select Contact "
        }
        centered
        visible={isForwardModalVisible}
        onOk={shareContact.contactDetail.length > 0 ? handleOk : () => { }}
        onCancel={handleCancel}
        cancelText="Cancel"
        okText="Share"
        maskClosable={false}
        cancelButtonProps={{ className: "urButton buttonWhite" }}
        okButtonProps={{ className: `urButton buttonBlue ${shareContact.contactDetail.length === 0 ? "disabled" : "urButton buttonBlue"}` }}
        className={`customPopup shareModel ${styles.newdeletechat}`}
      >
        <div className={styles.shareSelect}>
          <Select
            mode="multiple"
            onChange={(e: any) => onChangeSelectMembers(e)}
            onSearch={onSearchMembers}
            style={{ width: "100%" }}
            filterOption={false}
            showSearch={true}
            value={shareContact.selectedmember}
            placeholder="Search Name/ Group/ Extension"
            className="createNewSel"
            dropdownClassName="newChatSel"
          >
            {shareContact?.searchContactList?.map((contact: any, index: any) => {
              let name = contact?.caller_id ? contact?.caller_id : contact?.team_name;
              return (
                <option key={index} value={contact?.sip_login_id ? contact?.sip_login_id : `con${contact?.team_id}`}>
                  <div className="dropdowndesign">
                    <div className="usergroupss">

                      {contact?.team_id ? <URAvatarGroup className={`lefts size20 colorBG${random_color[index]} 
                    ${(contact?.profile_image_url !== null && contact?.profile_image_url !== "") ? 'avatarWithImg' : ""}`}
                        profileInfo={<> {contact?.profile_image_url ?
                          <span className="teamImg"><img src={teamIcn} alt="team icon" /></span> :
                          <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>} </>}
                      /> : <URAvatarGroup
                        className={`lefts size20 colorBG${random_color[index]} ${(contact?.ImageURL !== null && contact?.ImageURL !== "") ? 'avatarWithImg' : ""}`}
                        profileInfo={
                          <>
                            {contact?.ImageURL || contact?.profile_image_url ? (
                              <>
                                <img alt="" src={contact?.ImageURL ? contact.ImageURL : contact?.profile_image_url} />
                                <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                              </>
                            ) : (
                              <span>
                                {contact?.first_name?.charAt(0).toUpperCase() + contact?.last_name?.charAt(0).toUpperCase()}
                                <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                              </span>
                            )}
                          </>
                        }
                      />}
                    </div>
                    <div className="names">{name && name}</div>
                    {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                  </div>

                  {/* <div className="dropdowndesign">
                    <div className="usergroupss"><span>{name?.charAt(0)}<b></b></span></div>
                    <div className="names">{name && name}</div>
                    {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                  </div> */}
                </option>
              );
            })}
          </Select>
        </div>
        <div className=" scroller deleteScroll">
          {Array.isArray(chatReducer?.selectMessageData) &&
            chatReducer?.selectMessageData.map((data: any) => {
              let messageBody =
                data.message?.messageType === "IMAGE" || data.message?.messageType === "FILE" ? data.message.body : "";

              return (
                <>
                  <div className={`scroller ${styles.chatConSecBody}`}>
                    {(data.message?.messageType === "TEXT" || data.message?.messageType === "AT_MENTION") && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>

                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide forwardSec" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                              <p dangerouslySetInnerHTML={{ __html: urlify(data.message.body) }}></p>
                              {/* <ChatLike className='likeRight' placement="topRight"
                      tooltipTitle={data?.likeduserdetails} message={data}/> */}
                            </div>
                          </div>
                        </div>
                        <ChatRightInfo
                          userDetails={data.fromcaller_details}
                          isPopup={true}
                          timeStamp={data.timestamp}
                          message={data}
                        ></ChatRightInfo>
                      </div>
                    )}
                    {data.message?.messageType === "IMAGE" && imageFormat.indexOf(messageBody.fileType) !== -1 && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>
                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide forwardSec" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                              <div className={styles.imageChat}>
                                <div className={styles.imageSec}>
                                  <img src={messageBody.filePath} alt="" />
                                </div>
                              </div>
                              {/* <ChatLike className='likeRight' placement="topRight"
                      tooltipTitle={data?.likeduserdetails} message={data}/> */}
                            </div>
                            <Tooltip title="Today at 12:13 PM" className="cusTooltip" overlayClassName="customTooltip">
                              <div className={styles.chatTime}>12:13</div>
                            </Tooltip>
                          </div>
                        </div>
                        <ChatRightInfo
                          userDetails={data.fromcaller_details}
                          isPopup={true}
                          timeStamp={data.timestamp}
                          message={data}
                        ></ChatRightInfo>
                      </div>
                    )}
                    {data.message?.messageType === "FILE" && videoFormat.indexOf(messageBody.fileType) !== -1 && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>

                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide forwardSec" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                              <div className={styles.imageChat}>
                                <div className={styles.imageSec}>
                                  <video controls>
                                    <source src={messageBody?.filePath} type="video/mp4" />
                                  </video>
                                </div>
                              </div>
                              {/* <ChatLike className='likeRight' placement="topRight"
                      tooltipTitle={data?.likeduserdetails} message={data}/> */}
                            </div>
                            <Tooltip title="Today at 12:13 PM" className="cusTooltip" overlayClassName="customTooltip">
                              <div className={styles.chatTime}>12:13</div>
                            </Tooltip>
                          </div>
                        </div>
                        <ChatRightInfo
                          userDetails={data.fromcaller_details}
                          isPopup={true}
                          timeStamp={data.timestamp}
                          message={data}
                        ></ChatRightInfo>
                      </div>
                    )}
                    {data.message?.messageType === "FILE" &&
                      imageFormat.indexOf(messageBody.fileType) === -1 &&
                      videoFormat.indexOf(messageBody.fileType) === -1 &&
                      mp3Formats.indexOf(messageBody.fileType) === -1 && (
                        <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                          <div className={`${styles.chatUserDetails}`}>

                            <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide forwardSec" />
                          </div>
                          <div className={styles.chatRightMessages}>
                            <div className={styles.chatRight}>
                              <div className={styles.chatContent}>
                                <div className={styles.chatAttachmentList}>
                                  <div className={styles.filesChat}>
                                    <div className={styles.filesImage}>
                                      {zipFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconzip} alt="filename" />
                                      ) : pdfFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconpdf} alt="filename" />
                                      ) : pptFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconppt} alt="filename" />
                                      ) : excelFormats.indexOf(messageBody.fileType) !== -1 ? (
                                        <img src={iconxls} alt="filename" />
                                      ) : (
                                        <img src={iconword} alt="filename" />
                                      )}
                                    </div>
                                    <div className={styles.filesDetails}>
                                      <Tooltip
                                        placement="top"
                                        title={messageBody.fileName}
                                        overlayClassName="tooltipCenter"
                                      >
                                        <span className={styles.fileName}>
                                          {messageBody.fileName && messageBody.fileName.length > 25
                                            ? messageBody.fileName.substring(0, 25) + "..."
                                            : messageBody.fileName}
                                        </span>
                                      </Tooltip>
                                      <span className={styles.fileDt}>
                                        File size:{getFileSize(messageBody?.filesize)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {/* <ChatLike className='likeRight' placement="topRight"
                        tooltipTitle={data?.likeduserdetails} message={data}/> */}
                              </div>
                              <Tooltip
                                title="Today at 12:13 PM"
                                className="cusTooltip"
                                overlayClassName="customTooltip"
                              >
                                <div className={styles.chatTime}>12:13</div>
                              </Tooltip>
                            </div>
                          </div>
                          <ChatRightInfo
                            userDetails={data.fromcaller_details}
                            isPopup={true}
                            timeStamp={data.timestamp}
                            message={data}
                          ></ChatRightInfo>
                        </div>
                      )}
                    {data.message?.messageType === "FILE" && mp3Formats.indexOf(messageBody.fileType) !== -1 && (
                      <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                        <div className={`${styles.chatUserDetails}`}>

                          <ChatUserInfo userDetails={data.fromcaller_details} className="userinfoIcon rightSide forwardSec" />
                        </div>
                        <div className={styles.chatRightMessages}>
                          <div className={styles.chatRight}>
                            <div className={styles.chatContent}>
                              <ChatAudioInner data={data} userDetails={data.fromcaller_details} />
                              {/* <ChatLike className='likeRight' placement="topRight"
                          tooltipTitle={data?.likeduserdetails} message={data}/> */}
                            </div>
                            <Tooltip title="Today at 12:13 PM" className="cusTooltip" overlayClassName="customTooltip">
                              <div className={styles.chatTime}>12:13</div>
                            </Tooltip>
                          </div>
                        </div>
                        <ChatRightInfo
                          userDetails={data.fromcaller_details}
                          isPopup={true}
                          timeStamp={data.timestamp}
                          message={data}
                        ></ChatRightInfo>
                      </div>
                    )}
                  </div>
                </>
              );
            })}
        </div>
      </Modal>
    </>
  );
}
